<template>
    <v-form-element v-bind="safeProps">
        <vc-date-picker
            ref="input"
            :id="id" 
            v-model="date"
            :locale="$store.state.locale"
            :input-props='{
                class: className,
                placeholder: getPlaceholder(),
                readonly: disabled
            }'
            :masks="masks"
            :min-date="minDate"
            :max-date="maxDate"
            :popover="popover"
        ></vc-date-picker>
    </v-form-element>
</template>

<script>

    import DatePicker from 'v-calendar/lib/components/date-picker.umd';
    import FormElement from './Element';
    import mixin from './mixin';

    export default {
        components: {
            'v-form-element': FormElement,
            'vc-date-picker': DatePicker
        },
        data() {
            return {
                date: null
            }
        },
        props: {
            minDate: {
                default: null
            },
            maxDate: {
                default: null
            },
            popover: {
                required: false,
                type: Object,
                default() {
                    return {};
                }
            },
            masks: {
                required: false,
                type: Object,
                default() {
                    return {
                        data: 'YYYY-MM-DD', 
                        input: 'WWWW DD MMMM'
                    }
                }
            }
        },
        mixins: [mixin],
        computed: {
            safeProps: function () {
                /**
                 * Return this.$props without the popover key because it breaks on Chrome 
                 * thanks to the new popover API
                 */
                const { popover, ...safeProps } = this.$props;
                return safeProps;
            }
        },
        watch: {
            model() {
                this.setDateFromModel();
            },
            date() {
                if ( this.model !== window.moment(this.date).format('YYYY-MM-DD') && window.moment(this.model).format('YYYY-MM-DD') !== window.moment(this.date).format('YYYY-MM-DD') ) {
                    this.model = window.moment(this.date).format('YYYY-MM-DD');
                }
            }
        },
        methods: {
            setDateFromModel() {
                if ( this.model ) {
                    this.date = window.moment(this.model, 'YYYY-MM-DD').toDate();
                }
            }
        },
        created() {
            this.setDateFromModel();
        }
    }
</script>
